export default {
  formation: {
    home: {
      headTitle: 'Spécialiste de la réservation hôtelière pour les entreprises',
      subTitle: 'Vous faire gagner du temps en simplifiant les formalités, tout en réduisant vos dépenses',
      scrollText: 'RÉSERVER',
      text_1: 'BBA, Centrale de réservations hôtelières pour les entreprises, est mandatée par votre organisme de formation pour vous proposer des solutions d’hébergement à l’occasion de leur formation.',
      text_2: 'Quel que soit votre mode de réservation, vous bénéficiez d’un accompagnement et des meilleurs conditions tarifaires.'
    },
    cards: {
      offline: {
        title: 'OFFLINE',
        subTitle: 'Nous réservons pour vous',
        text_1: 'Vous faites une demande via un formulaire en ligne, un membre de l’équipe de B.B.A vous propose un hébergement en fonction de vos préférences géographiques et budgétaires.',
        text_2: 'B.B.A vous garantit une réponse dans les 24 heures, quel que soit le nombre de réservations, la période et/ou la proximité du déplacement.',
        send: 'ENVOYER'
      },
      online: {
        title: 'ONLINE',
        subTitle: 'Vous réservez par vous-même',
        text: 'Notre portail vous permet de réserver directement un hébergement parmi un large choix d’hôtels, partout dans le monde 24/24h et 7/7j. Vous prenez connaissance des disponibilités des hôtels et vous gérez vous-même vos réservations à votre convenance.',
        send: 'RÉSERVER'
      },
      specs: {
        mandatoryCard: 'Carte bancaire obligatoire',
        withoutFees: 'Modification ou annulation sans frais',
        onSitePayment: 'Règlement sur place par le voyageur',
        access: 'Accès 24h/24 7j/7',
        groups: 'Groupes et séminaires'
      }
    },
    map: {
      title: 'Qui sommes-nous',
      content: {
        text: 'B.B.A, spécialiste de la réservation hôtelière pour les entreprises depuis plus de 20 ans propose à ces clients de :',
        time: 'De faire gagner du temps en simplifiant les formalités, tout en réduisant vos dépenses',
        selection: 'D’accéder à la plus large sélection d’hôtels en France et à l’étranger.',
        experts: 'De bénéficier d’interlocuteurs qualifiés et expérimentés.',
        simplify: 'De simplifier la gestion des notes de frais'
      },
      address: 'B.B.A – 54 rue des Entrepôts  93400 Saint-Ouen',
      phone: 'Tél. +33 (0)1 49 21 55 90',
      fax: 'Fax. +33 (0)1 49 21 55 99',
      mail: 'reservation@netbba.com'
    },
    contact: {
      text_1: 'Vous souhaitez une information pour l’envoi d’une demande de réservation, une information sur nos formules, une question urgente, déposer une candidature ou une demande de partenariat (hôtel, centre de formation) ?',
      text_2: 'N’hésitez pas à utiliser le formulaire ci-contre.',
      form: {
        name: 'Nom',
        firstName: 'Prénom',
        email: 'Email',
        message: 'Message'
      },
      send: 'ENVOYER'
    },
    offline: {
      back: "Retour à l'accueil",
      title: 'Recherche offline',
      success: 'Votre demande a été correctement envoyée. Nous vous répondrons dans un délai de 4 heures ouvrées.',
      cb: {
        pattern: 'Type de carte détecté',
        visa: 'Visa',
        amex: 'American Express',
        mastercard: 'MasterCard'
      },
      formationOrganization: {
        label: 'Organisme de formation',
        placeholder: 'Le nom de l\'organisme de formation'
      },
      company: {
        label: 'Société',
        placeholder: 'Le nom de votre société'
      },
      contact: {
        label: 'Contact',
        placeholder: 'Nom Prénom'
      },
      phone: {
        label: 'Téléphone',
        placeholder: 'N° de téléphone'
      },
      email: {
        label: 'E-mail',
        placeholder: 'Email'
      },
      address: {
        label: 'Adresse',
        placeholder: 'Adresse'
      },
      city: {
        label: 'Ville',
        placeholder: 'Ville'
      },
      postCode: {
        label: 'Code Postal'
      },
      country: {
        label: 'Pays',
        placeholder: 'Pays'
      },
      debutSejour: {
        label: 'Début de séjour',
        placeholder: '(jj/mm/aaaa)'
      },
      finSejour: {
        label: 'Fin de séjour',
        placeholder: '(jj/mm/aaaa)'
      },
      nbNuits: {
        label: 'Nombre de nuits',
        placeholder: 'Nombre de nuits'
      },
      smokers: {
        label: 'Fumeurs'
      },
      category: {
        label: "Catégorie d'hôtel"
      },
      budget: {
        label: 'Budget par chambre et par nuit en euros',
        help: '(minimum pour Paris 2** , 75/85 euro hors petit déjeuner)'
      },
      rooms: {
        add: 'Ajouter',
        nom: {
          label: 'Nom',
          placeholder: 'Nom'
        },
        prenom: {
          label: 'Prénom',
          placeholder: 'Prénom'
        },
        typeChambre: {
          label: 'Type de chambre'
        }
      },
      formationPlace: {
        label: 'Lieu de la formation'
      },
      formationDistrict: {
        label: 'ou Quartier souhaité'
      },
      formationHotel: {
        label: 'ou Hôtel souhaité'
      },
      wishes: {
        label: 'Autres souhaits / commentaires'
      },
      searchPriority: {
        label: 'En cas de difficulté, priorité de recherche au'
      },
      textInfoHeader: {
        message: "<p>A réception de votre demande de réservation, vous recevrez une proposition de réservation répondant au mieux à vos critères de recherche.<br> Dés réception de cette proposition vous aurez le choix de l'accepter ou de la refuser voir de nous demander une nouvelle proposition.<br> Après acceptation de notre proposition votre responsabilité est engagées dans les 3 cas suivants :</p>"
      },
      textListEngagement: {
        message: "- Annulation tardive ( au delà des délais mentionnés sur notre confirmation)<br>- Réservation non-honorée<br>- Facture non réglée au depart de l'hôtel"
      },
      textListEngagement2: {
        message: "En l'absence de contrat avec notre agence (*) vous devez choisir l'un de ces deux modes suivants :"
      },
      paymentMethodCB: {
        label: '1 - Par carte bancaire : '
      },
      cbNumber: {
        label: 'Numéro de carte',
        placeholder: '#### #### #### ####'
      },
      cbOwner: {
        label: 'Nom du propriétaire',
        placeholder: 'Marc Dupond'
      },
      cbCrypto: {
        label: 'Cryptogramme',
        placeholder: '123'
      },
      cbValid: {
        label: 'Date de validité',
        placeholder: '12/25'
      },
      textInfosCB: {
        message: "(Ces coordonnées resteront en notre possession jusqu'à l'issue du séjour, ne serons pas conservées et ne seront pas communiquées à l'hôtel)."
      },
      paymentMethodApprove: {
        label: '2 - Approuver nos Conditions Générales de Réservation : '
      },
      textGarant: {
        message: "«Je me porte garant, en mon nom et celui de mon employeur, du règlement des frais qui pourraient découler de l'annulation tardive de la réservation ou de la non-présentation à l'hôtel pour le séjour dument confirmé à l'agence BBA.<br> J'ai pris connaissance que toute modification et annulation devront être confirmées par écrit (email ou fax) aux jours et heures d'ouvertures des bureaux de BBA. En l'absence de quoi et en cas de litige, ma responsabilité ou celle de mon employeur restera engagée »"
      },
      checkCGR: {
        text: '*j´ai lu et accepté « les conditions générales de réservation ».'
      }
    }
  }
}
